import React from "react"
import { Text } from "@mantine/core"
import SegueLink from "app/static/frontend/middleware/SegueLink"
import { useStyles } from "app/static/frontend/profiles-new/components/DTVCard/DTVCard.styles"

export const DTVCard = (props: any) => {
    const { title, segueUrl } = props
    const { classes } = useStyles()

    return (
        <div className={classes.segueContainer}>
            <SegueLink to={segueUrl}>
                <Text className={classes.textTitle}>{title}</Text>
            </SegueLink>
        </div>
    )
}
